import {
    Collapse, Link, Table,
    TableBody, TableCell, TableHead,
    TableRow, TextField, Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import axios from "axios";
import {formatDateUS} from "../../../../helpers/utils";
import ForbesAumRow from "./rows/ForbesAumRow";

const useStyles = makeStyles((theme) => ({
    contentSection: {
        padding: '16px 22px',
        background: '#fff',
        marginBottom: '15px',
        borderRadius: '3px',
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionHeaderTitle: {
        fontSize: '17px',
        fontWeight: '600',
        color: '#000',
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    form: {
        height: '100%',
    },
    field: {
        '& label.Mui-focused': {
            color: '#000',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#000',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#000',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#000',
            },
        },
    },
    tabActive: {
        color: '#1E69E5',
    },
    associationLink: {
        position: 'absolute',
        top: '-10px',
        right: '10px',
        cursor: 'pointer',
        decoration: 'none',
        '&:hover': {
            decoration: 'none',
        }
    },
    inheritFontWeight: {
        fontWeight: 'inherit',
    },
    tableMarginTop: {
        marginTop: 24,
    },
}));

const ContactsForbesAumsSection = ({session, contactCrdId, tab, handleTabChange}) => {
    const classes = useStyles()
    const [forbesAums, setForbesAums] = useState([])

    useEffect(() => {
        getForbesAums()
    }, [])

    const getForbesAums = () => {
        axios.get(
            '/v1/admin/forbes_aums/by_crd_id',
            {
                params: {crd_id: contactCrdId},
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': session.email,
                    'X-Admin-User-Token': session.token
                }
            }
        ).then((response) => {
            const {forbes_aums} = response.data;
            setForbesAums(forbes_aums)
        });
    }

    const headCells = [
        {id: 'year', label: 'Year'},
        {id: 'total_aum', label: 'AUM'},
        {id: 'minimum_account_size', label: 'Minimum Account Size'},
        {id: 'created_at', label: 'Import Date'},
        {id: 'automatic', label: 'Automated/Manual'},
    ];

    const handleRemoveItem = (event, id) => {
        axios.delete(
            `/v1/admin/forbes_aums/${id}`,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': session.email,
                    'X-Admin-User-Token': session.token
                }
            }
        ).then((response) => {
            getForbesAums()
        });
    }

    return (
        <React.Fragment>
            <div className={classes.contentSection}>
                <div className={classes.contentSectionHeader}
                     onClick={(event) => handleTabChange(event, 'newForbesAum')}>
                    <Typography variant='h5'
                                className={`${classes.contentSectionHeaderTitle} ${tab === 'newForbesAum' ? classes.tabActive : ''}`}>Rep AUM</Typography>
                    {tab === 'newForbesAum' ? <ExpandLess/> : <ExpandMore/>}
                </div>
                <Collapse in={tab === 'newForbesAum'}>
                    <div className={classes.contentSectionContent}>
                        <div className={classes.formGroup}>
                            {forbesAums ? <Table className={classes.tableMarginTop}>
                                <TableHead>
                                    <TableRow>
                                        {headCells.map((headCell) => (
                                            <TableCell key={headCell.id}>
                                                {headCell.label}
                                            </TableCell>
                                        ))}
                                        <TableCell/>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {forbesAums === undefined ?
                                        <TableRow><TableCell>Loading...</TableCell></TableRow> : forbesAums.map((forbesAum) => (
                                            <ForbesAumRow
                                                session={session}
                                                getForbesAums={getForbesAums}
                                                forbesAum={forbesAum}
                                            />
                                        ))}
                                </TableBody>
                            </Table> : null}
                        </div>
                    </div>
                </Collapse>
            </div>
        </React.Fragment>
    )
}

export default ContactsForbesAumsSection;